import {E} from "js-vextensions";
import {runInAction} from "mobx";
import {useEffect} from "react";
import {CheckBox, Column, Row, Text} from "react-vcomponents";
import {BaseComponentPlus} from "react-vextensions";
import {store} from "../../../Store";
import {CameraType} from "../../../Store/main/tools/@CameraConfig.js";
import {GetMonitorCameraConfig} from "../../../Store/main/tools/monitor.js";
import {InDesktop} from "../../../Utils/Bridge/Bridge_Native.js";
import {InfoButton, Observer, RunInAction_Set, Size, UseSize, BlobToArrayBuffer, RunInAction, GetSize_Method} from "web-vcore";
import {SaveStandaloneRecording} from "../../../Utils/Bridge/Bridge_Preload.js";
import {ScrollView} from "react-vscrollview";
import {ES} from "web-vcore";
import {currentCamera} from "../@Shared/CameraInterface.js";
import {CameraConfigUI} from "./CameraPanel/CameraConfigUI.js";
import {CameraMonitorChart} from "./CameraPanel/CameraMonitorChart.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

export const CameraPanel_Monitor = observer_mgl(() => {
	const uiState = store.main.tools.monitor;
	let canvasEl: HTMLCanvasElement|n;
	let canvasContext: CanvasRenderingContext2D|n;
	let chart: CameraMonitorChart|n;
	let previewContainerSize: Size;

	/*useEffect(() => {
		currentCamera.ConnectMonitorCameraPanel({
			StartRecording,
			StopRecording,
			canvasEl,
			canvasContext,
			chart,
			previewContainerSize,
		});
		return () => {
			currentCamera.DisconnectMonitorCameraPanel();
			if (uiState.record) {
				StopRecording();
			}
		};
	}, []);*/

	const StartRecording = () => {
		console.log("Starting recording.");
		const canvasStream = canvasEl!.captureStream();
		uiState.recorder = new MediaRecorder(canvasStream, { mimeType: "video/webm;codecs=vp9" });

		uiState.recorder.ondataavailable = (event) => {
			if (event.data.size > 0) {
				uiState.recordedChunks.push(event.data);
			}
		};
		uiState.recorder.start();

		RunInAction("CameraPanelMonitor_StartRecording", () => (uiState.record = true));
	};

	const StopRecording = () => {
		console.log("Stopping recording.");
		uiState.recorder.addEventListener("stop", async () => {
			const combinedBlob = new Blob(uiState.recordedChunks, { type: "video/webm" });
			const combinedArrayBuffer = await BlobToArrayBuffer(combinedBlob);
			SaveStandaloneRecording(combinedArrayBuffer);
		});
		uiState.recorder.stop();

		RunInAction("CameraPanelMonitor_StopRecording", () => (uiState.record = false));
		uiState.recorder = null;
		uiState.recordedChunks = [];
	};

	const [previewContainerRef, previewContainerSize_raw] = UseSize({ method: GetSize_Method.ScrollSize });
	previewContainerSize = { width: previewContainerSize_raw?.width ?? 0, height: previewContainerSize_raw?.height ?? 0 };

	const targetWidth = GetMonitorCameraConfig().resolution_width;
	const targetHeight = GetMonitorCameraConfig().resolution_height;

	return (
		<ScrollView style={ES({ flex: 1, padding: 10 })} contentStyle={{ display: "flex", flexDirection: "column" }}>
			<CameraConfigUI enabled={!uiState.preview} config={uiState.cameraConfig} onChange={(val) => RunInAction_Set(()=>(uiState.cameraConfig = val))} />
			<Row mt={20}>
				<Text style={{ fontWeight: "bold" }}>Preview options:</Text>
				<Text ml={5} style={{ opacity: 0.5 }}>
					(based on selected engine-config)
				</Text>
			</Row>
			<Column ml={15}>
				<Row mt={5}>
					<Text>Overlay:</Text>
					<CheckBox ml={10} text="Ignore rects" value={uiState.overlay_ignoreRects} onChange={(val) => RunInAction_Set(()=>(uiState.overlay_ignoreRects = val))} />
					<CheckBox ml={10} text="Pixel triggers" value={uiState.overlay_pixelTriggers} onChange={(val) => RunInAction_Set(()=>(uiState.overlay_pixelTriggers = val))} />
				</Row>
				<Row mt={5} center>
					<Text>Graph:</Text>
					<CheckBox ml={10} text="Trigger-pixel count" value={uiState.graph_triggerPixelCount} onChange={(val) => RunInAction_Set(()=>(uiState.graph_triggerPixelCount = val))} />
					<InfoButton
						ml={5}
						text={`
							Graphs the total number of pixels that were triggered, for each frame.
						`.AsMultiline(0)}
					/>
				</Row>
			</Column>
			<Row mt={5} center>
				<CheckBox
					text="Preview"
					enabled={uiState.cameraConfig.type == CameraType.Webcam || InDesktop()}
					value={uiState.preview}
					onChange={(val) => {
						RunInAction_Set(()=>{
							uiState.preview = val;
							if (!val && uiState.record) {
								StopRecording();
							}
						});
					}}
				/>
				<CheckBox
					ml={10}
					text="Record"
					enabled={uiState.preview}
					value={uiState.record}
					onChange={(val) => {
						if (val) StartRecording();
						else StopRecording();
					}}
				/>
				<InfoButton ml={5} text={`Stored to "$LFData/Standalone Recordings/$RecordTime.webm"`} />
			</Row>
			<div ref={previewContainerRef as any} style={E({position: "relative"}, !uiState.preview && { opacity: 0 }) as any}>
				<canvas
					ref={(c) => {
						canvasEl = c;
						canvasContext = c?.getContext("2d");
					}}
					width={targetWidth}
					height={targetHeight}
					style={{
						width: previewContainerSize.width,
						height: previewContainerSize.width * (targetHeight / targetWidth),
						display: "block",
					}}
				/>
				{uiState.graph_triggerPixelCount && (
					<div
						style={ES(
							uiState.record && {
								opacity: 0,
							}
						)}
					>
						<CameraMonitorChart ref={(c) => void (chart = c)} framesPerSecond={uiState.cameraConfig.framerate} />
					</div>
				)}
			</div>
		</ScrollView>
	);
});